<template>
  <div class="d-flex">
    <el-button
      v-if="
        permissions.some((per) => per.slug == name + '.' + 'show') ? true : false
      "
      style="background-color: #1890ff; border-color: #1890ff"
      @click="handleCommand('edit')"
      icon="el-icon-edit el-icon--left"
      round
    >
      <!-- {{ $t('message.update_setting') }} -->
    </el-button>
    <el-button
      v-if="
        permissions.some((per) => per.slug == name + '.' + 'delete')
          ? true
          : false
      "
      style="background-color: #ff4b55; border-color: #ff4b55"
      @click="handleCommand('delete')"
      icon="el-icon-delete el-icon--left"
      round
    >
      <!-- {{ $t('message.delete') }} -->
    </el-button>
  </div>
  <!-- </el-dropdown-menu> -->
  <!-- </el-dropdown> -->
</template>
<script>
import { mapGetters } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  props: {
    model: { type: Object, required: true },
    actions: { type: Array },
    name: { type: String, required: true },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      permissions: "auth/permissions",
    }),
  },
  methods: {
    handleCommand(command) {
      if (command === "delete") {
        this.$confirm(
          i18n.t("message.do_you_want"),
          i18n.t("message.warning"),
          {
            confirmButtonText: i18n.t("message.yes"),
            cancelButtonText: i18n.t("message.cancel"),
            type: "warning",
          }
        )
          .then(() => {
            this.$emit(command, this.model);
          })
          .catch(() => {
            this.$message({
              type: "warning",
              message: i18n.t("message.operation_canceled"),
            });
          });
      } else {
        this.$emit(command, this.model);
      }
    },
  },
};
</script>
<style>
.el-icon-delete,
.el-icon-edit {
  color: white;
}
</style>